import { defineNuxtPlugin } from '#app/nuxt'
import { LazyFrontendAccountCustomerGroupRegistrationPage, LazyFrontendDetailPage, LazyFrontendLandingPage, LazyFrontendNavigationPage, LazyLanguageSwitcher, LazyLoadingOverlay, LazyAccountAddressCard, LazyAccountAddressForm, LazyAccountChangePassword, LazyAccountLoginForm, LazyAccountLoginFormPlain, LazyAccountMenu, LazyAccountOrder, LazyAccountOrderDetails, LazyAccountOrderDownloads, LazyAccountOrderLineItem, LazyAccountOrderSummary, LazyAccountPersonalData, LazyAccountPersonalEmail, LazyAccountRecoverPassword, LazyAccountRegisterForm, LazyAccountResetPasswordForm, LazyAccountOrderLineItemCredit, LazyAccountOrderLineItemCustom, LazyAccountOrderLineItemProduct, LazyAccountOrderLineItemPromotion, LazyCheckoutCartItem, LazyCheckoutFreeShippingBar, LazyCheckoutPromotionCode, LazyCheckoutSideCart, LazyCheckoutSteps, LazyCheckoutCartProductItem, LazyCheckoutCartPromotionItem, LazyCmsSwContactForm, LazyCmsSwNewsletterForm, LazyCmsSwProductCard, LazyCmsBlockBioCircle, LazyCmsBlockGalleryBuybox, LazyCmsBlockHtml, LazyCmsBlockImageTextBubble, LazyCmsBlockImageThreeColumn, LazyCmsBlockSidebarFilter, LazyCmsBlockText, LazyCmsBlockTextThreeColumn, LazyCmsBlockTextTwoColumn, LazyCmsElementBigBoxWhite, LazyCmsElementBioBreadCrumbs, LazyCmsElementBioCrossSelling, LazyCmsElementBuyBox, LazyCmsElementCategoryNavigation, LazyCmsElementCategorySlider, LazyCmsElementCrossSelling, LazyCmsElementFaq, LazyCmsElementFlowBoxes, LazyCmsElementForm, LazyCmsElementGreenBoxes, LazyCmsElementHeroContent, LazyCmsElementHeroImage, LazyCmsElementHeroSlider, LazyCmsElementHtml, LazyCmsElementImage, LazyCmsElementImageGallery, LazyCmsElementImageSlider, LazyCmsElementImageTextBlocks, LazyCmsElementImageWithHeadline, LazyCmsElementLogoSlider, LazyCmsElementMixedBoxes, LazyCmsElementMultipleImageTextRows, LazyCmsElementNewsletter, LazyCmsElementPackageMatrix, LazyCmsElementPlainTextBlocks, LazyCmsElementProductCycle, LazyCmsElementProductDescriptionReviews, LazyCmsElementProductDetailGrid, LazyCmsElementProductGrid, LazyCmsElementProductListing, LazyCmsElementProductSlider, LazyCmsElementReferenceBox, LazyCmsElementRowContentPlain, LazyCmsElementSidebarFilter, LazyCmsElementSkillBoxes, LazyCmsElementSocialMedia, LazyCmsElementTeamBox, LazyCmsElementTestApplicationForm, LazyCmsElementTestimonials, LazyCmsElementText, LazyCmsElementTextLeftContactRight, LazyCmsElementTextLeftMediaRight, LazyCmsElementWhiteBoxes, LazyCmsElementProductSlideCard, LazyCmsHelpersBuildUrlPrefix, LazyCmsHelpersGetUrlPrefix, LazyCmsSectionDefault, LazyCmsSectionSidebar, LazyCmsSkeletonProductCardSkeleton, LazyErrorsMaintainMode, LazyErrorsRoutingNotFound, LazyLayoutHeaderRight, LazyLayoutHeaderRightMobile, LazyLayoutBreadcrumbs, LazyLayoutCheckoutHeader, LazyLayoutCustomFooter, LazyLayoutFooter, LazyLayoutHeader, LazyLayoutMegaMenu, LazyLayoutNotification, LazyLayoutNotifications, LazyLayoutServiceNavigation, LazyLayoutSideMenu, LazyLayoutSidebar, LazyLayoutStoreSearch, LazyLayoutTopNavigation, LazyLayoutTopNavigationRecursive, LazyListingFiltersSwCategoryNavigation, LazyListingFiltersSwCategoryNavigationLink, LazyListingFiltersSwFilterPrice, LazyListingFiltersSwFilterPropertiesOrg, LazyListingFiltersSwFilterProperties, LazyListingFiltersSwFilterRating, LazyListingFiltersSwFilterShippingFree, LazyListingFiltersSwProductListingFilter, LazyListingFiltersSwProductListingFilters, LazyProductCard, LazyProductReviews, LazyProductReviewsForm, LazyProductSuggestSearch, LazyProductUnits, LazyProductSwListingProductPrice, LazyProductDetailConfiguration, LazyProductDetailConfigurationCleanerItem, LazyProductDetailConfigurationItem, LazyProductDetailConfigurationServiceItem, LazyProductDetailCrossSelling, LazyProductDetailMobGalleryImg, LazyProductDetailProductAddToCart, LazyProductDetailProductImageGallery, LazyProductDetailProductImagePopup, LazyProductDetailProductPrice, LazyProductDetailProductVariantConfigurator, LazyProductDetailRequestQuotation, LazyProductDetailYoutubeVideo, LazyServerUseCachedCategory, LazyServerUseCachedCmsElementsFromCategory, LazyServerUseCachedCmsElementsFromCategoryWithChilds, LazyServerUseCachedMainNavigation, LazyServerUseCachedMediaById, LazyServerUseCachedPaymentMethods, LazyServerUseCachedProduct, LazyServerUseCachedSeoRedirect, LazyServerUseCachedVariants, LazyServerUseClearProductCache, LazySharedAccountAddressForm, LazySharedButton, LazySharedCountryStateInput, LazySharedFancybox, LazySharedHeadline, LazySharedLink, LazySharedListingProductPrice, LazySharedModal, LazySharedPagination, LazySharedPrice, LazySharedRangeSlider, LazySharedTopline, LazySharedWishlist, LazyUtilitiesGtmTrackings, LazyUtilities, LazyCmsGenericBlock, LazyCmsGenericElement, LazyCmsNoComponent, LazyCmsPage, LazyCmsBlockCategoryNavigation, LazyCmsBlockCenterText, LazyCmsBlockCrossSelling, LazyCmsBlockCustomForm, LazyCmsBlockDefault, LazyCmsBlockForm, LazyCmsBlockImage, LazyCmsBlockImageBubbleRow, LazyCmsBlockImageCover, LazyCmsBlockImageFourColumn, LazyCmsBlockImageGallery, LazyCmsBlockImageHighlightRow, LazyCmsBlockImageSimpleGrid, LazyCmsBlockImageSlider, LazyCmsBlockImageText, LazyCmsBlockImageTextCover, LazyCmsBlockImageTextGallery, LazyCmsBlockImageTextRow, LazyCmsBlockImageThreeCover, LazyCmsBlockImageTwoColumn, LazyCmsBlockProductDescriptionReviews, LazyCmsBlockProductHeading, LazyCmsBlockProductListing, LazyCmsBlockProductSlider, LazyCmsBlockProductThreeColumn, LazyCmsBlockTextHero, LazyCmsBlockTextOnImage, LazyCmsBlockTextTeaser, LazyCmsBlockTextTeaserSection, LazyCmsBlockVimeoVideo, LazyCmsBlockYoutubeVideo, LazyCmsElementCustomForm, LazyCmsElementImageGallery3dPlaceholder, LazyCmsElementManufacturerLogo, LazyCmsElementProductBox, LazyCmsElementProductName, LazyCmsElementVimeoVideo, LazyCmsElementYoutubeVideo, LazyProductCardSkeleton, LazyUnoIcon } from '#components'
const lazyGlobalComponents = [
  ["FrontendAccountCustomerGroupRegistrationPage", LazyFrontendAccountCustomerGroupRegistrationPage],
["FrontendDetailPage", LazyFrontendDetailPage],
["FrontendLandingPage", LazyFrontendLandingPage],
["FrontendNavigationPage", LazyFrontendNavigationPage],
["LanguageSwitcher", LazyLanguageSwitcher],
["LoadingOverlay", LazyLoadingOverlay],
["AccountAddressCard", LazyAccountAddressCard],
["AccountAddressForm", LazyAccountAddressForm],
["AccountChangePassword", LazyAccountChangePassword],
["AccountLoginForm", LazyAccountLoginForm],
["AccountLoginFormPlain", LazyAccountLoginFormPlain],
["AccountMenu", LazyAccountMenu],
["AccountOrder", LazyAccountOrder],
["AccountOrderDetails", LazyAccountOrderDetails],
["AccountOrderDownloads", LazyAccountOrderDownloads],
["AccountOrderLineItem", LazyAccountOrderLineItem],
["AccountOrderSummary", LazyAccountOrderSummary],
["AccountPersonalData", LazyAccountPersonalData],
["AccountPersonalEmail", LazyAccountPersonalEmail],
["AccountRecoverPassword", LazyAccountRecoverPassword],
["AccountRegisterForm", LazyAccountRegisterForm],
["AccountResetPasswordForm", LazyAccountResetPasswordForm],
["AccountOrderLineItemCredit", LazyAccountOrderLineItemCredit],
["AccountOrderLineItemCustom", LazyAccountOrderLineItemCustom],
["AccountOrderLineItemProduct", LazyAccountOrderLineItemProduct],
["AccountOrderLineItemPromotion", LazyAccountOrderLineItemPromotion],
["CheckoutCartItem", LazyCheckoutCartItem],
["CheckoutFreeShippingBar", LazyCheckoutFreeShippingBar],
["CheckoutPromotionCode", LazyCheckoutPromotionCode],
["CheckoutSideCart", LazyCheckoutSideCart],
["CheckoutSteps", LazyCheckoutSteps],
["CheckoutCartProductItem", LazyCheckoutCartProductItem],
["CheckoutCartPromotionItem", LazyCheckoutCartPromotionItem],
["CmsSwContactForm", LazyCmsSwContactForm],
["CmsSwNewsletterForm", LazyCmsSwNewsletterForm],
["CmsSwProductCard", LazyCmsSwProductCard],
["CmsBlockBioCircle", LazyCmsBlockBioCircle],
["CmsBlockGalleryBuybox", LazyCmsBlockGalleryBuybox],
["CmsBlockHtml", LazyCmsBlockHtml],
["CmsBlockImageTextBubble", LazyCmsBlockImageTextBubble],
["CmsBlockImageThreeColumn", LazyCmsBlockImageThreeColumn],
["CmsBlockSidebarFilter", LazyCmsBlockSidebarFilter],
["CmsBlockText", LazyCmsBlockText],
["CmsBlockTextThreeColumn", LazyCmsBlockTextThreeColumn],
["CmsBlockTextTwoColumn", LazyCmsBlockTextTwoColumn],
["CmsElementBigBoxWhite", LazyCmsElementBigBoxWhite],
["CmsElementBioBreadCrumbs", LazyCmsElementBioBreadCrumbs],
["CmsElementBioCrossSelling", LazyCmsElementBioCrossSelling],
["CmsElementBuyBox", LazyCmsElementBuyBox],
["CmsElementCategoryNavigation", LazyCmsElementCategoryNavigation],
["CmsElementCategorySlider", LazyCmsElementCategorySlider],
["CmsElementCrossSelling", LazyCmsElementCrossSelling],
["CmsElementFaq", LazyCmsElementFaq],
["CmsElementFlowBoxes", LazyCmsElementFlowBoxes],
["CmsElementForm", LazyCmsElementForm],
["CmsElementGreenBoxes", LazyCmsElementGreenBoxes],
["CmsElementHeroContent", LazyCmsElementHeroContent],
["CmsElementHeroImage", LazyCmsElementHeroImage],
["CmsElementHeroSlider", LazyCmsElementHeroSlider],
["CmsElementHtml", LazyCmsElementHtml],
["CmsElementImage", LazyCmsElementImage],
["CmsElementImageGallery", LazyCmsElementImageGallery],
["CmsElementImageSlider", LazyCmsElementImageSlider],
["CmsElementImageTextBlocks", LazyCmsElementImageTextBlocks],
["CmsElementImageWithHeadline", LazyCmsElementImageWithHeadline],
["CmsElementLogoSlider", LazyCmsElementLogoSlider],
["CmsElementMixedBoxes", LazyCmsElementMixedBoxes],
["CmsElementMultipleImageTextRows", LazyCmsElementMultipleImageTextRows],
["CmsElementNewsletter", LazyCmsElementNewsletter],
["CmsElementPackageMatrix", LazyCmsElementPackageMatrix],
["CmsElementPlainTextBlocks", LazyCmsElementPlainTextBlocks],
["CmsElementProductCycle", LazyCmsElementProductCycle],
["CmsElementProductDescriptionReviews", LazyCmsElementProductDescriptionReviews],
["CmsElementProductDetailGrid", LazyCmsElementProductDetailGrid],
["CmsElementProductGrid", LazyCmsElementProductGrid],
["CmsElementProductListing", LazyCmsElementProductListing],
["CmsElementProductSlider", LazyCmsElementProductSlider],
["CmsElementReferenceBox", LazyCmsElementReferenceBox],
["CmsElementRowContentPlain", LazyCmsElementRowContentPlain],
["CmsElementSidebarFilter", LazyCmsElementSidebarFilter],
["CmsElementSkillBoxes", LazyCmsElementSkillBoxes],
["CmsElementSocialMedia", LazyCmsElementSocialMedia],
["CmsElementTeamBox", LazyCmsElementTeamBox],
["CmsElementTestApplicationForm", LazyCmsElementTestApplicationForm],
["CmsElementTestimonials", LazyCmsElementTestimonials],
["CmsElementText", LazyCmsElementText],
["CmsElementTextLeftContactRight", LazyCmsElementTextLeftContactRight],
["CmsElementTextLeftMediaRight", LazyCmsElementTextLeftMediaRight],
["CmsElementWhiteBoxes", LazyCmsElementWhiteBoxes],
["CmsElementProductSlideCard", LazyCmsElementProductSlideCard],
["CmsHelpersBuildUrlPrefix", LazyCmsHelpersBuildUrlPrefix],
["CmsHelpersGetUrlPrefix", LazyCmsHelpersGetUrlPrefix],
["CmsSectionDefault", LazyCmsSectionDefault],
["CmsSectionSidebar", LazyCmsSectionSidebar],
["CmsSkeletonProductCardSkeleton", LazyCmsSkeletonProductCardSkeleton],
["ErrorsMaintainMode", LazyErrorsMaintainMode],
["ErrorsRoutingNotFound", LazyErrorsRoutingNotFound],
["LayoutHeaderRight", LazyLayoutHeaderRight],
["LayoutHeaderRightMobile", LazyLayoutHeaderRightMobile],
["LayoutBreadcrumbs", LazyLayoutBreadcrumbs],
["LayoutCheckoutHeader", LazyLayoutCheckoutHeader],
["LayoutCustomFooter", LazyLayoutCustomFooter],
["LayoutFooter", LazyLayoutFooter],
["LayoutHeader", LazyLayoutHeader],
["LayoutMegaMenu", LazyLayoutMegaMenu],
["LayoutNotification", LazyLayoutNotification],
["LayoutNotifications", LazyLayoutNotifications],
["LayoutServiceNavigation", LazyLayoutServiceNavigation],
["LayoutSideMenu", LazyLayoutSideMenu],
["LayoutSidebar", LazyLayoutSidebar],
["LayoutStoreSearch", LazyLayoutStoreSearch],
["LayoutTopNavigation", LazyLayoutTopNavigation],
["LayoutTopNavigationRecursive", LazyLayoutTopNavigationRecursive],
["ListingFiltersSwCategoryNavigation", LazyListingFiltersSwCategoryNavigation],
["ListingFiltersSwCategoryNavigationLink", LazyListingFiltersSwCategoryNavigationLink],
["ListingFiltersSwFilterPrice", LazyListingFiltersSwFilterPrice],
["ListingFiltersSwFilterPropertiesOrg", LazyListingFiltersSwFilterPropertiesOrg],
["ListingFiltersSwFilterProperties", LazyListingFiltersSwFilterProperties],
["ListingFiltersSwFilterRating", LazyListingFiltersSwFilterRating],
["ListingFiltersSwFilterShippingFree", LazyListingFiltersSwFilterShippingFree],
["ListingFiltersSwProductListingFilter", LazyListingFiltersSwProductListingFilter],
["ListingFiltersSwProductListingFilters", LazyListingFiltersSwProductListingFilters],
["ProductCard", LazyProductCard],
["ProductReviews", LazyProductReviews],
["ProductReviewsForm", LazyProductReviewsForm],
["ProductSuggestSearch", LazyProductSuggestSearch],
["ProductUnits", LazyProductUnits],
["ProductSwListingProductPrice", LazyProductSwListingProductPrice],
["ProductDetailConfiguration", LazyProductDetailConfiguration],
["ProductDetailConfigurationCleanerItem", LazyProductDetailConfigurationCleanerItem],
["ProductDetailConfigurationItem", LazyProductDetailConfigurationItem],
["ProductDetailConfigurationServiceItem", LazyProductDetailConfigurationServiceItem],
["ProductDetailCrossSelling", LazyProductDetailCrossSelling],
["ProductDetailMobGalleryImg", LazyProductDetailMobGalleryImg],
["ProductDetailProductAddToCart", LazyProductDetailProductAddToCart],
["ProductDetailProductImageGallery", LazyProductDetailProductImageGallery],
["ProductDetailProductImagePopup", LazyProductDetailProductImagePopup],
["ProductDetailProductPrice", LazyProductDetailProductPrice],
["ProductDetailProductVariantConfigurator", LazyProductDetailProductVariantConfigurator],
["ProductDetailRequestQuotation", LazyProductDetailRequestQuotation],
["ProductDetailYoutubeVideo", LazyProductDetailYoutubeVideo],
["ServerUseCachedCategory", LazyServerUseCachedCategory],
["ServerUseCachedCmsElementsFromCategory", LazyServerUseCachedCmsElementsFromCategory],
["ServerUseCachedCmsElementsFromCategoryWithChilds", LazyServerUseCachedCmsElementsFromCategoryWithChilds],
["ServerUseCachedMainNavigation", LazyServerUseCachedMainNavigation],
["ServerUseCachedMediaById", LazyServerUseCachedMediaById],
["ServerUseCachedPaymentMethods", LazyServerUseCachedPaymentMethods],
["ServerUseCachedProduct", LazyServerUseCachedProduct],
["ServerUseCachedSeoRedirect", LazyServerUseCachedSeoRedirect],
["ServerUseCachedVariants", LazyServerUseCachedVariants],
["ServerUseClearProductCache", LazyServerUseClearProductCache],
["SharedAccountAddressForm", LazySharedAccountAddressForm],
["SharedButton", LazySharedButton],
["SharedCountryStateInput", LazySharedCountryStateInput],
["SharedFancybox", LazySharedFancybox],
["SharedHeadline", LazySharedHeadline],
["SharedLink", LazySharedLink],
["SharedListingProductPrice", LazySharedListingProductPrice],
["SharedModal", LazySharedModal],
["SharedPagination", LazySharedPagination],
["SharedPrice", LazySharedPrice],
["SharedRangeSlider", LazySharedRangeSlider],
["SharedTopline", LazySharedTopline],
["SharedWishlist", LazySharedWishlist],
["UtilitiesGtmTrackings", LazyUtilitiesGtmTrackings],
["Utilities", LazyUtilities],
["CmsGenericBlock", LazyCmsGenericBlock],
["CmsGenericElement", LazyCmsGenericElement],
["CmsNoComponent", LazyCmsNoComponent],
["CmsPage", LazyCmsPage],
["CmsBlockCategoryNavigation", LazyCmsBlockCategoryNavigation],
["CmsBlockCenterText", LazyCmsBlockCenterText],
["CmsBlockCrossSelling", LazyCmsBlockCrossSelling],
["CmsBlockCustomForm", LazyCmsBlockCustomForm],
["CmsBlockDefault", LazyCmsBlockDefault],
["CmsBlockForm", LazyCmsBlockForm],
["CmsBlockImage", LazyCmsBlockImage],
["CmsBlockImageBubbleRow", LazyCmsBlockImageBubbleRow],
["CmsBlockImageCover", LazyCmsBlockImageCover],
["CmsBlockImageFourColumn", LazyCmsBlockImageFourColumn],
["CmsBlockImageGallery", LazyCmsBlockImageGallery],
["CmsBlockImageHighlightRow", LazyCmsBlockImageHighlightRow],
["CmsBlockImageSimpleGrid", LazyCmsBlockImageSimpleGrid],
["CmsBlockImageSlider", LazyCmsBlockImageSlider],
["CmsBlockImageText", LazyCmsBlockImageText],
["CmsBlockImageTextCover", LazyCmsBlockImageTextCover],
["CmsBlockImageTextGallery", LazyCmsBlockImageTextGallery],
["CmsBlockImageTextRow", LazyCmsBlockImageTextRow],
["CmsBlockImageThreeCover", LazyCmsBlockImageThreeCover],
["CmsBlockImageTwoColumn", LazyCmsBlockImageTwoColumn],
["CmsBlockProductDescriptionReviews", LazyCmsBlockProductDescriptionReviews],
["CmsBlockProductHeading", LazyCmsBlockProductHeading],
["CmsBlockProductListing", LazyCmsBlockProductListing],
["CmsBlockProductSlider", LazyCmsBlockProductSlider],
["CmsBlockProductThreeColumn", LazyCmsBlockProductThreeColumn],
["CmsBlockTextHero", LazyCmsBlockTextHero],
["CmsBlockTextOnImage", LazyCmsBlockTextOnImage],
["CmsBlockTextTeaser", LazyCmsBlockTextTeaser],
["CmsBlockTextTeaserSection", LazyCmsBlockTextTeaserSection],
["CmsBlockVimeoVideo", LazyCmsBlockVimeoVideo],
["CmsBlockYoutubeVideo", LazyCmsBlockYoutubeVideo],
["CmsElementCustomForm", LazyCmsElementCustomForm],
["CmsElementImageGallery3dPlaceholder", LazyCmsElementImageGallery3dPlaceholder],
["CmsElementManufacturerLogo", LazyCmsElementManufacturerLogo],
["CmsElementProductBox", LazyCmsElementProductBox],
["CmsElementProductName", LazyCmsElementProductName],
["CmsElementVimeoVideo", LazyCmsElementVimeoVideo],
["CmsElementYoutubeVideo", LazyCmsElementYoutubeVideo],
["ProductCardSkeleton", LazyProductCardSkeleton],
["UnoIcon", LazyUnoIcon],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
